"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _typeof2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _lang = _interopRequireDefault(require("@/lang"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _index = _interopRequireDefault(require("@/components/Pagination/index"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _validate = require("@/utils/validate");

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
var _default = {
  name: "agentCost:view",
  props: ['agentId'],
  extends: _PermissionPage.default,
  components: {
    Pagination: _index.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  watch: {
    'addInformationParameter.minAmount': function addInformationParameterMinAmount(newVal, oldVal) {
      if (!(0, _validate.isMoney)(newVal, false, this.numberOfDecimal)) this.addInformationParameter.minAmount = oldVal;
    },
    'addInformationParameter.costValue': function addInformationParameterCostValue(newVal, oldVal) {
      this.addInformationParameter.costValue = (0, _validate.check_num)(newVal);
    }
  },
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      agentList: null,
      total: 0,
      listLoading: false,
      addDialogVisible: false,
      channelOperatorList: [],
      channelList: [],
      areaOption: [],
      costRatio: 100,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        agentId: '',
        channelId: '',
        netwayCode: '',
        currency: ""
      },
      addInformationParameter: {
        id: '',
        agentId: '',
        channelId: '',
        costValue: '',
        minAmount: '',
        state: '',
        netwayCode: '',
        currency: "",
        description: '',
        remark: ''
      },
      downloadLoading: false,
      multipleSelection: [],
      netwayCodeEnums: [],
      numberOfDecimal: 0,
      rules: {
        currency: [{
          required: true,
          message: _lang.default.t('channel.currencyText') + " " + _lang.default.t('warningMessage.cannotBeEmpty'),
          trigger: 'blur'
        }],
        costValue: [{
          required: true,
          message: _lang.default.t('agent.costText') + " " + _lang.default.t('warningMessage.cannotBeEmpty'),
          trigger: 'blur'
        }],
        channelId: [{
          required: true,
          message: _lang.default.t("agent.channelText") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['costStatusOption', 'statusOptions', 'useOptions', 'netwayCodeOption', 'informationOptions', 'numberRegionOptions', 'currencyTypeOption'])),
  created: function created() {
    var _this2 = this;

    this.handleNetwayCode();

    if (this.agentId != undefined) {
      this.getCostRatio();
      this.getPayChannelList();
      this.getList();
    } else {
      //Go back to previous webpage and remove tag
      this.$store.dispatch('tagsView/delView', this.$route).then(function () {
        _this2.$router.go(-1);
      });
    }
  },
  mounted: function mounted() {
    if (this.agentId != undefined) {
      this.getList();
      this.getPayChannelList();
      this.getNumberOfDecimal();
    } else {
      //Go back to previous webpage
      this.$router.go(-1);
    }
  },
  methods: {
    handleNetwayCode: function handleNetwayCode() {
      this.netwayCodeEnums = this.$store.getters.netwayCodeEnums;

      if (this.netwayCodeEnums == null || (0, _typeof2.default)(this.netwayCodeEnums) != 'object' || this.netwayCodeEnums.length < 1) {
        this.netwayCodeEnums = this.netwayCodeOption;
      }
    },
    convertCostByRatio: function convertCostByRatio(cost) {
      return parseInt(cost) / this.costRatio;
    },
    getNetwayCodeByPayChannel: function getNetwayCodeByPayChannel() {
      var _this3 = this;

      this.channelList.forEach(function (status) {
        if (parseInt(status.channelId) == _this3.addInformationParameter.channelId) {
          _this3.addInformationParameter.netwayCode = status.netwayCode;
          return;
        }
      });
    },
    convertChannelIdToChannelName: function convertChannelIdToChannelName(channelId) {
      var found = '';
      this.channelList.forEach(function (status) {
        if (parseInt(status.channelId) == channelId) {
          found = status.channelName;
          return;
        }
      });
      return found;
    },
    convertNetwayCodeToName: function convertNetwayCodeToName(key) {
      var found = '';
      this.netwayCodeEnums.forEach(function (status) {
        if (status.key == key) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    getList: function getList() {
      var _this4 = this;

      if (this.agentId === undefined) {
        this.$store.dispatch('tagsView/delView', this.$route).then(function () {
          _this4.$router.go(-1);
        });
      }

      var params = this.getQueryParams();
      this.listLoading = true;

      _httpUtils.default.post("agentCost", "list", null, params).then(function (res) {
        _this4.list = res.data.rows;
        _this4.total = res.data.total;
        _this4.listLoading = false;
      });

      setTimeout(function () {
        _this4.listLoading = false;
      }, 1 * 1000);
    },
    getPayChannelList: function getPayChannelList() {
      var _this5 = this;

      _httpUtils.default.post("payChannel", "getPayChannelOption", null, null).then(function (res) {
        //let index;
        _this5.channelList = res.data;
      });
    },
    getCostRatio: function getCostRatio() {
      var _this6 = this;

      _httpUtils.default.post("code", "getCostRatio", null, null).then(function (res) {
        //let index;
        _this6.costRatio = parseInt(res.data.costRatio.name);
      });
    },
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        agentId: this.agentId,
        channelId: this.queryParameter.channelId,
        netwayCode: this.queryParameter.netwayCode
      };
    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        id: this.addInformationParameter.id,
        agentId: this.agentId,
        channelId: this.addInformationParameter.channelId,
        value: this.addInformationParameter.costValue,
        minAmount: this.addInformationParameter.minAmount,
        state: this.addInformationParameter.state,
        description: this.addInformationParameter.description,
        remark: this.addInformationParameter.remark,
        netwayCode: this.addInformationParameter.netwayCode,
        currency: this.addInformationParameter.currency
      };
    },
    handleAdd: function handleAdd() {
      var _this7 = this;

      var _this = this;

      this.$refs['addInformation'].validate(function (valid) {
        if (valid) {
          var params = _this.getAddInformationParameter();

          if (_this.updateChannelFlag) {
            _this7.listLoading = true;

            _httpUtils.default.post("agentCost", "update", null, params).then(function (res) {
              if (res.code === 200) {
                _this7.$notify({
                  title: _lang.default.t("message.organizationManagementMessage20"),
                  message: res.data,
                  type: "success",
                  duration: 2000
                });
              }

              if (res.code === 500) {
                _this7.$message({
                  message: _lang.default.t('warningMessage.channelCostExistMessage'),
                  type: 'warning'
                });
              }

              _this7.handleResetAdd();

              _this7.handleFilter();
            }).catch(function (error) {
              _this7.$message({
                message: error.message,
                type: 'error'
              });
            });

            setTimeout(function () {
              _this7.listLoading = false;
            }, 1 * 1000);
          } else {
            _this7.listLoading = true;

            _httpUtils.default.post("agentCost", "update", null, params).then(function (res) {
              if (res.code === 200) {
                _this7.$notify({
                  title: _lang.default.t("message.organizationManagementMessage20"),
                  message: res.data,
                  type: "success",
                  duration: 2000
                });
              }

              if (res.code === 500) {
                _this7.$message({
                  message: _lang.default.t('warningMessage.channelCostExistMessage'),
                  type: 'warning'
                });
              }

              _this7.handleResetAdd();

              _this7.handleFilter();
            }).catch(function (error) {
              _this7.$message({
                message: error.message,
                type: 'error'
              });
            });

            setTimeout(function () {
              _this7.listLoading = false;
            }, 1 * 1000);
          }
        } else {
          return false;
        }
      });
    },
    deleteAgentCost: function deleteAgentCost(agentCostIds) {
      var _this8 = this;

      _httpUtils.default.post("agentCost", "batchDelete", null, agentCostIds).then(function (res) {
        _this8.$message({
          message: _lang.default.t('warningMessage.deleteRecordSuccessMessage'),
          type: 'success'
        });

        _this8.handleFilter();
      }).catch(function (err) {
        _this8.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleDelete: function handleDelete(id) {
      var _this9 = this;

      this.$confirm(_lang.default.t('warningMessage.deleteChannelCostConfirmMessage'), _lang.default.t('warningMessage.deleteChannelCostMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        var agentCostIds = [];
        agentCostIds.push(id);

        _this9.$nextTick(function (_) {
          _this9.deleteAgentCost(agentCostIds);
        });
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this10 = this;

      var _this = this;

      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t('warningMessage.selectRecordToDeleteMessage'),
          type: 'error'
        });
      } else {
        this.$confirm(_lang.default.t('warningMessage.deleteChannelCostConfirmMessage'), _lang.default.t('warningMessage.deleteChannelCostMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          var agentCostIds = [];

          for (var item in _this.multipleSelection) {
            agentCostIds.push(_this.multipleSelection[item].id);
          }

          _this10.$nextTick(function (_) {
            _this10.deleteAgentCost(agentCostIds);
          });
        }).catch(function (_) {});
      }
    },
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.addInformationParameter.id = row.id;
      this.addInformationParameter.channelId = parseInt(row.channelId);
      this.addInformationParameter.costValue = row.value;
      this.addInformationParameter.minAmount = row.minAmount;
      this.addInformationParameter.description = row.description;
      this.addInformationParameter.remark = row.remark;
      this.addInformationParameter.netwayCode = row.netwayCode;
      this.addInformationParameter.currency = row.currency;
      this.addDialogVisible = true;
      this.updateChannelFlag = true;
    },
    handleReset: function handleReset() {
      this.addInformationParameter.id = null;
      this.addInformationParameter.channelId = '';
      this.addInformationParameter.costValue = '';
      this.addInformationParameter.minAmount = '';
      this.addInformationParameter.description = '';
      this.addInformationParameter.remark = '';
      this.addInformationParameter.netwayCode = '';
      this.addInformationParameter.currency = "";
    },
    handleResetAdd: function handleResetAdd() {
      var _this11 = this;

      this.handleReset();
      this.addDialogVisible = false;
      this.updateChannelFlag = false;
      this.$nextTick(function (_) {
        _this11.$refs['addInformation'].clearValidate();
      });
    },
    convertInformationName: function convertInformationName(name) {
      var found = '';
      this.informationOptions.forEach(function (item) {
        if (item.key == name) {
          found = item.display_name;
          return;
        }
      });
      return found;
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //Convert currency
    convertCurrencyCodeToName: function convertCurrencyCodeToName(val) {
      if (!this.currencyTypeOption || !this.currencyTypeOption.length) return;
      var currency = this.currencyTypeOption.find(function (currency) {
        return currency.key === val;
      });

      if (currency) {
        return currency.display_name;
      } else {
        return "";
      }
    },
    getNumberOfDecimal: function getNumberOfDecimal() {
      var _this12 = this;

      _httpUtils.default.post("agentCost", "getNumberOfDecimal", {}, null).then(function (res) {
        _this12.numberOfDecimal = res.data.numberOfDecimal;
      }).catch(function (err) {
        _this12.$message({
          message: err.message,
          type: 'error'
        });
      });
    }
  }
};
exports.default = _default;